import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {

  constructor(private http: HttpClient) {
  }

  intialize() {
    return () => {
      return this.http.get('/assets/config.json')
        .toPromise()
        .then((configuration) => {
          this.configureEnvironment(configuration);
        });
    };
  }

  configureEnvironment(configuration: any) {
    // Internal Users
    environment.production = configuration.production;
    environment.internal = (window.location.hostname === configuration.int.hostname) ? true : false;

    environment.int.customProvider = configuration.int.customProvider;
    environment.int.hostname = configuration.int.hostname;

    environment.int.cognito.identityPoolId = configuration.int.cognito.identityPoolId;
    environment.int.cognito.userPoolId = configuration.int.cognito.userPoolId;
    environment.int.cognito.userPoolWebClientId = configuration.int.cognito.userPoolWebClientId;
    environment.int.cognito.oauth.domain = configuration.int.cognito.oauth.domain;
    environment.int.cognito.oauth.redirectSignIn = configuration.int.cognito.oauth.redirectSignIn;
    environment.int.cognito.oauth.redirectSignOut = configuration.int.cognito.oauth.redirectSignOut;

    // External Users
    environment.ext.customProvider = configuration.ext.customProvider;
    environment.ext.hostname = configuration.int.hostname;

    environment.ext.cognito.identityPoolId = configuration.ext.cognito.identityPoolId;
    environment.ext.cognito.userPoolId = configuration.ext.cognito.userPoolId;
    environment.ext.cognito.userPoolWebClientId = configuration.ext.cognito.userPoolWebClientId;
    environment.ext.cognito.oauth.domain = configuration.ext.cognito.oauth.domain;
    environment.ext.cognito.oauth.redirectSignIn = configuration.ext.cognito.oauth.redirectSignIn;
    environment.ext.cognito.oauth.redirectSignOut = configuration.ext.cognito.oauth.redirectSignOut;

    // API Endpoints
    for (let i = 0; i < configuration.api.endpoints.length; i++) {
      environment.api.endpoints[i].name = configuration.api.endpoints[i].name;
      environment.api.endpoints[i].endpoint = configuration.api.endpoints[i].endpoint;
      environment.api.endpoints[i].service = configuration.api.endpoints[i].service;
      environment.api.endpoints[i].region = configuration.api.endpoints[i].region;
    }

    // S3 bucket
    environment.s3.bucket = configuration.s3.bucket;

    // Kaltura Player
    environment.kaltura = configuration.kaltura;

    // User Session
    environment.user = configuration.user;
  }
}
